import React from 'react';
import { PropTypes } from 'prop-types';

const renderChildren = (children) =>
    children.map((child, index) => {
        if (index + 1 >= children.length) {
            child = { ...child, props: { ...child.props, isLast: true } };
        }

        return child;
    });

const SectionBreadcrumbs = ({ children }) => (
    <>
        {children && (
            <div className="d-flex align-items-center flex-wrap text-background">{renderChildren(children)}</div>
        )}
    </>
);

SectionBreadcrumbs.propTypes = {
    children: PropTypes.array.isRequired,
};

export default SectionBreadcrumbs;
